const extractMessageFromData = (data: unknown): string | undefined => {
  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (data && typeof data === "object") {
    const payload = data as Record<string, unknown>;
    const candidates = [
      payload.message,
      payload.detail,
      payload.title,
      payload.error,
    ];

    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim()) {
        return candidate;
      }
    }
  }

  return undefined;
};

export class ApiError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export const handlingError = (error: any): never => {
  if (error.response) {
    const status = error.response.status;
    const message =
      extractMessageFromData(error.response.data) ?? `Error ${status}`;

    throw new ApiError(message, status);
  }

  if (error.request) {
    throw new ApiError(String(error.request));
  }

  throw new ApiError(error.message ?? "Unknown error");
};
